module.exports = "/img/like_purple.svg?dd62f8aaf72add89b5bea8e70a06d785";